import { useAuth } from '@/contexts/AuthContext'
import type { UxPreference } from '@/types'

/**
 * Legge la preferenza UX dell'utente loggato.
 * Nessuna chiamata API aggiuntiva — il campo arriva già con il user object.
 *
 * @returns preference: 'responsive' | 'mobile-first' | 'adaptive'
 */
export function useUxPreference(): { preference: UxPreference } {
  const { user } = useAuth()
  const preference: UxPreference = user?.ux_preference ?? 'responsive'
  return { preference }
}
